module.exports = __webpack_public_path__ + "static/img/Hexagon_Tool.013cbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/Hexagon_Tool.png
// module id = 1105
// module chunks = 21